import React, { Component } from "react";
import FormInputFields from '../../../../FormInputFields';
import Wrp from '../../../../../hoc/Wrp/Wrp';
import Buttons from '../../../../../Components/UI/Buttons';

class ExchangeRateConversion  extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepsMode:'CURRENCY',
            formInputs:{
                changeCurrency:(this.props.currency_code===undefined)?'CAD':this.props.currency_code,
                totalValue:0,
                exchange_rate: '',
                from_currency_code: "",
                to_currency_code: "",
                value: ''
            }
        }
     this.selectorRef = React.createRef(null);
    }
   
    onChangeHandler = (key,value)=>{
        //console.log(key, value, '---------');        
        this.setState({
        stepsMode:'CURRENCY',
        formInputs:{
            ...this.state.formInputs,
            [key]:value
        }})

        if(key==='changeCurrency'){
            setTimeout(() => {
              this.getExChangeHandler();
             }, 100);            
        }
    }
    componentDidUpdate = (prevProps)=>{             
        if(this.props.exchangeRates!==prevProps.exchangeRates){            
            this.setState({
                stepsMode:'EXCHANGERATE',
                formInputs:{
                ...this.state.formInputs,
                ...this.props.exchangeRates
            } })                
        }
                        
    }

    componentDidMount = () => {
        this.onChangeHandler('changeCurrency',this.props.currency_code)
    }
    
    getExChangeHandler = ()=>{
        const {currency_code,currencyValue} = this.props;
        const {formInputs} = this.state;
        const currentCurrency = (currency_code===undefined)?'CAD':currency_code;
        this.props.updateCurrencyValueByFormat({
          fromCode:currentCurrency,
          toCode:formInputs.changeCurrency,
          selectedValue:currencyValue, 
        },true);
    }
    recalculateHandler = ()=>{
        const {currencyValue} = this.props;
        const {formInputs} = this.state;
        const totalValue = (formInputs.exchange_rate*currencyValue);
        this.setState({stepsMode:'GENERATE',
        formInputs:{
            ...formInputs,
            totalValue:totalValue
        }})
    }
    applyChangeHandler = ()=>{
        const {formInputs} = this.state;
        const updateData = this.props.fieldObj;
          //exchangeRate
        this.props.onChangeInputAction(updateData,this.props.toFixedHandler(formInputs.totalValue),'number');
        this.props.onChangeInputAction(updateData,formInputs.changeCurrency,'currencyType');  
        this.props.onChangeInputAction(updateData,formInputs.exchange_rate,'exchangeRate');  
        this.props.applyAndClose(this.props.toFixedHandler((formInputs.totalValue)));
        this.selectorRef.current.click();
    }
    render(){
        const {formInputs} = this.state;
        const {currencyList,currencyValue,currency_code,isOpenCurrencyConversion,toogleConvertCurrency} = this.props;
        let currencyListOptions = [];//{value:'-None-',id:''}
        currencyList.map((currency)=>{
            currencyListOptions.push({
                value:currency.value,
                id:currency.key
            });
        });
        //onClick={toogleConvertCurrency}
        return(
                <>
                <button type="button"  ref={this.selectorRef} data-toggle="dropdown" className="btn btn-primary dropdown-toggle  sign-up-btn"  ariaExpanded="true"> Change Currency </button>
               
                <Wrp>
                <div className="dropdown-menu dropnotHide " style={{"minWidth":"35rem"}}> 
					<div className="card-header bg-transparent p-1" style={{"border":"none"}}> 
						<div className="form-group mb-0 row">
						    <label className="text-small col-6 text-right"> From Currency <span className="badge badge-default"> {currency_code} </span> </label>
						    <div className="col-3">
                            <FormInputFields  
                                {...{
                                    type:'TextInput',
                                    options:currencyListOptions,
                                    value:currencyValue,
                                    attributes:{
                                        readOnly:'readOnly',
                                        className:"form-control form-control-sm",
                                        id:'from_currency',
                                        name:'from_currency',
                                    },
                                }} />
							</div>
						</div>
					</div>
					<div className="card-body">
						<div className="row">
							<div className="col-6">
								<div className="form-group">
									<label className="text-small"> Change Currency To </label>
									<div className="">
                                            {/* Currency list */}
                                       <FormInputFields  
                                            {...{
                                            type:'PickList',
                                            isDefault:true,
                                            isMandatory:true,
                                            isNoneAllowed:false,
                                            options:currencyListOptions,
                                                value:formInputs.changeCurrency,
                                                attributes:{
                                                    id:'changeCurrency',
                                                    name:'changeCurrency',
                                                },
                                            changeHandler:this.onChangeHandler.bind(this,'changeCurrency'),
                                        }} />
                                    </div>
								</div>
						    </div>
					        <div className="col-6">
								<div className="form-group"> 
									<label className="text-small"> Exchange Rate <code> ( for "100" ) </code></label>
									<div className=""> 
										<div className="input-group">
											<FormInputFields  {...{
                                                    type:'Decimal',
                                                    value:formInputs.exchange_rate,
                                                    changeHandler:this.onChangeHandler.bind(this,'exchange_rate'),
                                                    attributes:{
                                                        // readOnly:'readOnly',
                                                        className:"form-control form-control-sm",
                                                        id:'from_currency',
                                                        name:'from_currency',
                                                    },
                                                    min:0
                                                }} />
											<div className="input-group-append">
                                            <Buttons 
                                                buttonList={[
                                                    {
                                                    clickHandler:this.recalculateHandler,
                                                    attributes:{
                                                        className:"btn primary_bg",
                                                    },
                                                    disabled:(formInputs.exchange_rate!==undefined && formInputs.exchange_rate!=='')?false:true,
                                                    name:"Re-calculate"
                                                    }
                                                ]}/>
											</div>
										</div> 
									</div>								 
								</div>
                                <div className="form-group row mb-0">		 
									<div className="col-12"> 
										<div className="input-group">
                                            <FormInputFields  
                                                {...{type:'TextInput',
                                                    value:formInputs.totalValue,
                                                    attributes:{
                                                        readOnly:'readOnly',
                                                        className:"form-control form-control-sm",
                                                    }}} />
											<div className="input-group-append">
												<span className="input-group-text p-1" id="basic-addon2"> Total </span>
											</div>
										</div>
									</div>								 
								</div>
							</div>
						</div>	 
					</div>
					<div className="card-footer bg-transparent p-1">
					    <div className="row align-items-center justify-content-center"> 
                        <Buttons 
                            buttonList={[
                                {
                                clickHandler:this.applyChangeHandler,
                                attributes:{
                                    "className":"btn primary_bg mr-3",
                                     // 'data-toggle':"dropdown",
                                },
                                disabled:(this.state.stepsMode==='GENERATE')?false:true,
                                name:"Apply"
                                },
                                {
                                attributes:{
                                    className:"btn btn-border border-default",

                                    
                                },
                                clickHandler:()=>{this.selectorRef.current.click(); toogleConvertCurrency()},
                                name:"Close"
                                }
                            ]}/>
						</div>
				    </div>
                </div>
                 {/* <div className="bg-overlay overlayVisible" style={{zIndex:'999'}}></div> */}
                 </Wrp>
                
               
             </>    
        )
    }
}
export default ExchangeRateConversion;